import type { RegistryEntry, UiOptionSelect, UiOptionSlider } from '../types';
import { clampTo } from '../../tools';

const KREA_CREATIVITY_OPTION = {
  key: 'creativity',
  label: 'Creativity',
  type: 'select',
  options: [
    { label: 'Raw', value: 'raw' },
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
    { label: 'High', value: 'high' },
  ],
  default: 'medium',
  group: 'inline',
} as UiOptionSelect;

const KREA_STRENGTH_OPTION = {
  key: 'strength',
  label: 'Strength',
  type: 'slider',
  min: 0,
  max: 1,
  step: 0.05,
  default: 0.8,
  group: 'basic',
} as UiOptionSlider;

const toKreaProviderOptions = (ui: Record<string, any>) =>
  ({
    creativity: clampTo(
      ui.creativity || 'medium',
      ['raw', 'low', 'medium', 'high'] as const,
      'medium',
    ),
  }) as unknown as Record<string, Record<string, any>>;

const kreaCreativityEntry: RegistryEntry = {
  options: [KREA_CREATIVITY_OPTION],
  toProviderOptions: toKreaProviderOptions,
};

const kreaTurboEntry: RegistryEntry = {
  options: [KREA_STRENGTH_OPTION],
  toProviderOptions: (ui) => {
    const raw = Number(ui.strength);
    return {
      strength: Number.isFinite(raw) ? Math.min(1, Math.max(0, raw)) : 0.8,
    } as unknown as Record<string, Record<string, any>>;
  },
};

export const kreaConfigs: Record<string, RegistryEntry> = {
  'krea-v2-large': kreaCreativityEntry,
  'krea-v2-medium': kreaCreativityEntry,
  'krea-v2-medium-turbo': kreaCreativityEntry,
  'krea-v2-turbo': kreaTurboEntry,
};
